import type { AllComponents } from "../interfaces/base";
import { editorTemplateMatchesComponent } from "./componentIdentity";

export function shouldRenderWebpageRoot(options: {
  component: AllComponents | null | undefined;
  editorTemplate: Pick<AllComponents, "id" | "uuid"> | null | false | undefined;
  knownComponentTypes: Record<string, unknown>;
}): boolean {
  const { component, editorTemplate, knownComponentTypes } = options;

  if (
    editorTemplate &&
    component &&
    editorTemplateMatchesComponent(editorTemplate, component)
  ) {
    return false;
  }

  if (!component) {
    return false;
  }

  if (component.sort_order === -44) {
    return false;
  }

  if (!knownComponentTypes[component.type]) {
    return false;
  }

  return true;
}
